var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "plane-picture-container" }, [
    !!_vm.plane
      ? _c("div", { staticClass: "plane-picture" }, [
          _c("img", {
            ref: "img",
            attrs: { src: "/api/planes/" + _vm.plane.id + "/main-picture" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "plane-picture-info-container" }, [
            _c("div", { staticClass: "plane-passengers-max" }, [
              _c("img", { attrs: { src: "/imgs/icons/passager.svg" } }),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("registration.passengers-max", {
                      maxPassengers: _vm.plane.max_passengers
                    })
                  )
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "plane-weight-max" }, [
              _c("img", { attrs: { src: "/imgs/icons/poids.svg" } }),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("registration.weight-max", {
                      maxWeight: _vm.plane.max_weight
                    })
                  )
                }
              })
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-897240f0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-897240f0","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/plane-picture.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-897240f0","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/plane-picture.vue
// module chunks = 1 2 3